import { render } from "./missedAppointments.vue?vue&type=template&id=dca68f6c"
import script from "./missedAppointments.vue?vue&type=script&lang=js"
export * from "./missedAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__